
import React, { useState } from 'react';
import {
    Box, Grid, Typography, Container as MuiContainer, Tabs, Tab, Accordion,
    AccordionSummary,
    AccordionDetails,
    Paper,
    Avatar,
    Container,
    Card,
    CardMedia,
    CardContent,
    Stack,
    Button,
    IconButton,
    Divider,
    Select,
    InputLabel,
    FormControl,
    TextField,
    MenuItem,
} from '@mui/material';
import image from "../../assets/NEET-REPEATERS.jpg"
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import photo1 from "../../assets/Kavnish.jpg"
import photo2 from "../../assets/Hamda-2-copy.jpg"
import photo3 from "../../assets/gowrishankar_test.png"
import photo4 from "../../assets/lulu-a-1.png"
import image1 from "../../assets/JEE-ADV-REPEATERS.jpg"
import image2 from "../../assets/JEE-MAIN-REPEATERS.jpg"
import image3 from "../../assets/long-term-2026.jpg"
import image4 from "../../assets/LONG-TERM-2-WEB-1.jpg"
import Header from '../../common/Header';
import GroupsIcon from '@mui/icons-material/Groups';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import ComputerIcon from '@mui/icons-material/Computer';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import AutoPopUp from '../AutoPopUp';
import DetailAutoPopUp from './DetailAutoPopUp';


const courseDetails = [
    {
        icon: <GroupsIcon fontSize="medium" />,
        title: 'Target Group',
        description: 'FOR CLASS XII COMPLETED STUDENTS',
    },
    {
        icon: <AccessTimeIcon fontSize="medium" />,
        title: 'Duration',
        description: 'One Year',
    },
    {
        icon: <GroupIcon fontSize="medium" />,
        title: 'Programme',
        description: 'ONLINE & CLASS ROOM',
    },
    {
        icon: <PersonIcon fontSize="medium" />,
        title: 'Admission Time',
        description: 'Registration Continues',
    },
    {
        icon: <ComputerIcon fontSize="medium" />,
        title: 'Admission Criteria',
        description: 'Based on Plus Two mark and NEET Score',
    },
    {
        icon: <ThumbUpAltIcon fontSize="medium" />,
        title: 'Commences',
        description: 'Commences in June',
    },
    {
        icon: <ApartmentIcon fontSize="medium" />,
        title: 'Centres',
        description: `Offline Centres : Trivandrum, Kollam, Pala, Ernakulam, Thrissur, Kottakkal, Kozhikode, Kannur\n\nCentres For Non Keralite Batches : Pala & Trivandrum`,
    },
];



const faqData = [
    {
        question: 'What Is The Criteria For Admissions To Offered By Brilliant Study Centre, Pala',
        answer: (
            <>
                <Typography variant="body1" gutterBottom>
                    A students should satisfy any one of the following three criteria
                </Typography>
                <Typography variant="body1" component="div">
                    i. Based on the marks of physics, chemistry and Biology in Plus Two Board Examination.<br />
                    ii. Based on the Score/NEET Exam
                </Typography>
            </>
        ),
    },
    {
        question: 'How Can I Register For Medical Repeaters Programme?',
        answer: (
            <>
                <Typography gutterBottom sx={{ mb: 2 }}>
                    You can register by following the steps given below
                </Typography>
                <Typography variant='body1' gutterBottom>
                    1.(Only for Non – registered student): Create student ID & Password at student portal of Brilliant
                    website & upload photo
                </Typography>
                <Typography variant='body1' gutterBottom>
                    2. Login with ID and password and go to programme update qualification
                </Typography>
                <Typography variant='body1' gutterBottom>
                    3. Apply for the respective course
                </Typography>
                <Typography variant='body1' gutterBottom>
                    4. If you satisfy the Brilliant criteria, within 24 hours confirmation of admission and payment
                    details will be send by sms
                </Typography>
            </>
        ),
    },
    {
        question: 'What Is The Mode Of Payment Of Fees?',
        answer: (
            <Typography gutterBottom>
                Go to “fee payment” and make payment using internet banking/debit/credit card. Direct payment can be made at South Indian Bank counter using the Brilliant Challan obtained
            </Typography>
        ),
    },
    {
        question: 'What Is The Teaching Methodology Followed By Brilliant',
        answer: (
            <Typography>
                The methodology developed by us followed in our programme lays emphasis on imbibing fundamental concepts in Biology, Physics and Chemistry and on sharpening their analytical skills and parallel thinking process.
            </Typography>
        ),
    },
    {
        question: 'What About – The Hostel Facility Provided By Brilliant?',
        answer: (
            <Typography>
                Every student selected to the Brilliant Medical Repeaters Batch will get a seat in Brilliant hostel or approved private hostel where the students are under the direct control of wardens.
            </Typography>
        ),
    },
];


const testimonials = [
    {
        text: 'The academics in Brilliant were exceptional... I am very pleased...',
        name: 'RR KAVINESH',
        img: photo1,
    },
    {
        text: 'Brilliant was pivotal for my success. Their praised system of...',
        name: 'HAMDA RAHMAN',
        img: photo2,
    },
    {
        text: 'Pointing out profound dedication, guidance, motivation, and support given by...',
        name: 'GOWRISHANKAR S',
        img: photo3,
    },
    {
        text: 'I think the experience and the exposure to different teaching...',
        name: 'LULU A',
        img: photo4,
    },
];

const courses = [
    {
        title: 'Repeaters-IIT (JEE Advanced) 2026 – One Year Programme',
        image: image1,
    },
    {
        title: 'Repeaters 2026 JEE Main – One Year Programme',
        image: image2,
    },
    {
        title: 'LONG TERM 2026 – One Year Programme',
        image: image3,
    },
    {
        title: 'LONG TERM 2027 – Two Year Programme',
        image: image4,
    },
];

const videoList = [
    {
        title: 'React Crash Course',
        url: 'https://www.youtube.com/embed/jDBoiZYJO6s',
    },
    {
        title: 'Material UI Tutorial',
        url: 'https://www.youtube.com/embed/tgXVE6kDsJg',
    },
    {
        title: 'JavaScript Basics',
        url: 'https://www.youtube.com/embed/5c8A2CZtwwI',
    },
];


const RepeatersNEET = () => {

    const [value, setValue] = useState(0);
    const [expanded, setExpanded] = useState('panel0');
    const [name, setName] = useState();
    const [mobile, setMobile] = useState();
    const [selectClass, setSelectClass] = useState();
    const [openPopup, setOpenPopup] = useState(false);

    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    const handleAccordionToggle = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [form, setForm] = React.useState({
        name: '',
        mobile: '',
        class: '',
    });

    const handleChangee = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };




    return (
        <Grid container sx={{ backgroundColor: '#ecf3fa', }}>
            <Header />
            <Grid container item sx={{ display: 'flex', p: 3, mt: { md: 10, xs: 5 } }} spacing={4}>
                {/* Left Side - Accordions */}
                <Grid item md={8} xs={12}>
                    <Grid item >
                        <img src={image} alt="Repeaters NEET Program" style={{ width: '100%', height: 'auto' }} />
                    </Grid>
                    <Grid item xs={12} md={12} sx={{ mt: { md: 4, xs: 2 } }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            sx={{
                                backgroundColor: '#0071BC',
                                '& .MuiTabs-flexContainer': {
                                    justifyContent: { xs: 'flex-start', md: 'space-between' },
                                },
                                '& .MuiTab-root': {
                                    color: '#fff',
                                    fontWeight: 700,
                                    fontSize: { xs: '1rem', md: '1.125rem' },
                                    textTransform: 'none',
                                    // minWidth: 'auto', // allows tabs to shrink naturally
                                    // horizontal padding for better tap targets
                                },
                                '& .Mui-selected': {
                                    backgroundColor: '#fff',
                                    color: '#000',
                                },
                            }}
                        >
                            <Tab label="Introduction" />
                            <Tab label="Description" />
                            <Tab label="FAQs" />
                            <Tab label="Testimonials" />
                        </Tabs>

                        {value === 0 && (
                            <Box sx={{ pt: 4 }}>
                                <Typography sx={{ fontSize: '1.125rem', lineHeight: 2 }}>
                                    <Link href="#" underline="hover" sx={{ color: '#007bff', fontWeight: 500 }}>
                                        Brilliant study centre
                                    </Link>
                                    , the pioneer in entrance coaching was established in 1984. Ever since its inception it has been providing excellent coaching facilities for Medical and Engineering entrance examinations. Medical entrance programme began in Brilliant more than a decade ago and within a short span of time Brilliant has proved to be the best entrance coaching institute for MBBS aspirants. Over the last 40 years we have been able to contribute more than 1 lakh doctors.
                                </Typography>
                                <Typography sx={{ fontSize: '1.125rem', lineHeight: 2, mt: 3 }}>
                                    A star attraction of our Medical Entrance programme is the “One year Repeaters Programme”. This unique venture of Brilliant is a systematic, target oriented and most exhaustive learning programme for those who have passed/completed Class XII. The effective course plan, the updated notes, experienced and dedicated faculty, advanced infrastructure and overall learning atmosphere guarantee and outstanding success for MBBS aspirants to get admission to AIIMS/JIPMER/AFMC and other Medical colleges.
                                </Typography>
                            </Box>
                        )}

                        {value === 1 && (
                            <Box sx={{ pt: 4 }}>
                                <Typography>Brilliant Study Center is offering the best entrance coaching for medical aspirants through the NEET 2025 Repeaters batch. This is a one-year program where the students can join either an online batch or an offline batch with a 100% scholarship. Through this Repeaters programme, we are aiming to help students get admission to the most prestigious medical institutes in India. The classes will be taken by top faculties in an advanced learning and teaching environment. To accommodate students from all over India, there will be separate batches for non-Keralite students.

                                    Join our course and start your preparation now!!!</Typography>
                            </Box>
                        )}

                        {value === 2 && (
                            <Box sx={{ pt: 4 }}>
                                <Grid sx={{ width: '100%', fontFamily: 'Arial, sans-serif' }}>
                                    {faqData.map((item, index) => (
                                        <Accordion
                                            key={index}
                                            expanded={expanded === `panel${index}`}
                                            onChange={handleAccordionToggle(`panel${index}`)}
                                            sx={{
                                                borderRadius: 0,
                                                boxShadow: 'none',
                                                borderBottom: '4px solid white',
                                                backgroundColor: expanded === `panel${index}` ? '#0071bc' : '#0071bc',
                                                color: '#fff',
                                                '&:before': {
                                                    display: 'none',
                                                },
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={
                                                    expanded === `panel${index}` ? (
                                                        <RemoveIcon sx={{ color: '#fff' }} />
                                                    ) : (
                                                        <AddIcon sx={{ color: '#fff' }} />
                                                    )
                                                }
                                                aria-controls={`panel${index}bh-content`}
                                                id={`panel${index}bh-header`}
                                            >
                                                <Typography sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                                                    {item.question}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails
                                                sx={{
                                                    backgroundColor: '#fff',
                                                    color: '#000',
                                                    padding: '20px',
                                                    fontSize: '1rem',
                                                    lineHeight: 1.6,
                                                }}
                                            >
                                                {item.answer}
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Grid>
                            </Box>
                        )}

                        {value === 3 && (
                            <Box sx={{ pt: 6, pb: 10 }}>
                                <Box sx={{ px: { xs: 2, sm: 0 } }}>
                                    <Grid container spacing={10}>
                                        {testimonials.map((item, index) => (
                                            <Grid item xs={12} sm={6} md={6} key={index}>
                                                <Paper
                                                    elevation={2}
                                                    sx={{
                                                        p: 4,
                                                        height: '100%',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'space-between',
                                                        borderRadius: 2,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: '1.3rem',
                                                            fontWeight: 400,
                                                            color: '#222',
                                                            lineHeight: 1.6,
                                                        }}
                                                    >
                                                        "{item.text}"
                                                    </Typography>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                        <Avatar
                                                            src={item.img}
                                                            alt={item.name}
                                                            sx={{ width: 70, height: 70 }}
                                                        />
                                                        <Typography
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                color: '#0077CC',
                                                                textTransform: 'uppercase',
                                                                fontSize: '1.05rem',
                                                            }}
                                                        >
                                                            {item.name}
                                                        </Typography>
                                                    </Box>
                                                </Paper>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                            </Box>
                        )}
                    </Grid>
                </Grid>

                {/* Right Side - Rightside Components */}
                <Grid item md={4} xs={12} sx={{ display: 'flex', flexDirection: 'column', }}>
                    <Grid sx={{ width: '100%', maxWidth: 400, }}>
                        <Stack spacing={2}>
                            {/* Register Button - Green */}
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    borderRadius: '8px',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    textTransform: 'none',
                                    height: 50,
                                    '&:hover': {
                                        backgroundColor: '#218838',
                                    },
                                }}
                                fullWidth
                                onClick={() => setOpenPopup(true)}
                            >
                                Register
                            </Button>

                            {/* Request A Call Back - Yellow */}
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#ffc107',
                                    color: '#000',
                                    borderRadius: '8px',
                                    fontSize: '20px',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    height: 50,
                                    '&:hover': {
                                        backgroundColor: '#e0a800',
                                    },
                                }}
                                fullWidth
                                  onClick={() => setOpenPopup(true)}
                            >
                                Request A Call Back
                            </Button>

                            {/* COURSE BROCHURE - Outlined */}
                            <Button
                                variant="outlined"
                                sx={{
                                    borderRadius: '40px',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    border: '2px solid #003366',
                                    color: '#003366',
                                    height: 60,
                                    '&:hover': {
                                        border: '2px solid #002244',
                                        backgroundColor: '#f0f8ff',
                                    },
                                }}
                                fullWidth
                                  onClick={() => setOpenPopup(true)}
                            >
                                Course Brochure
                            </Button>

                            {/* Screening Test Sample Que Paper - Cyan */}
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#18a9b9',
                                    color: 'white',
                                    borderRadius: '40px',
                                    fontSize: '20px',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    height: 60,
                                    whiteSpace: 'nowrap',
                                    '&:hover': {
                                        backgroundColor: '#1495a3',
                                    },
                                }}
                                fullWidth
                                  onClick={() => setOpenPopup(true)}
                            >
                                Screening Test Sample Que Paper
                            </Button>

                            {/* Course Video - Cyan */}
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#18a9b9',
                                    color: 'white',
                                    borderRadius: '40px',
                                    fontSize: '20px',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    height: 60,
                                    '&:hover': {
                                        backgroundColor: '#1495a3',
                                    },
                                }}
                                fullWidth
                                  onClick={() => setOpenPopup(true)}
                            >
                                Course Video
                            </Button>

                            {/* Registration Video - Cyan */}
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: '#18a9b9',
                                    color: 'white',
                                    borderRadius: '40px',
                                    fontSize: '20px',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    height: 60,
                                    '&:hover': {
                                        backgroundColor: '#1495a3',
                                    },
                                }}
                                fullWidth
                                  onClick={() => setOpenPopup(true)}
                            >
                                Registration Video
                            </Button>
                        </Stack>
                    </Grid>
                    <Grid sx={{ mt: 4 }}>
                        <Box sx={{ p: 4, backgroundColor: '#f8f9fb', borderRadius: '4px' }}>
                            <Typography variant="h4" fontWeight={700} gutterBottom>
                                Course Details
                            </Typography>

                            {courseDetails.map((item, index) => (
                                <Box key={index} sx={{ py: 2 }}>
                                    <Stack direction="row" spacing={2} alignItems="center">
                                        <Box sx={{ color: '#1e1f20' }}>{item.icon}</Box>
                                        <Box>
                                            <Typography variant="subtitle1" fontWeight={600}>
                                                {item.title}
                                            </Typography>
                                            <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                                                {item.description}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                    {index < courseDetails.length - 1 && (
                                        <Divider sx={{ mt: 2 }} />
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                </Grid>

            </Grid>

            {/* Related Courses */}
            <Grid sx={{ backgroundColor: '#f4f6f8', p: 2 }}>
                <Grid>
                    <Typography
                        variant="h4"
                        fontWeight={700}
                        sx={{ mb: 4, color: '#1e1e1e' }}
                    >
                        Related Courses
                    </Typography>
                    <Grid container spacing={3}>
                        {courses.map((course, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                                <Card sx={{ borderRadius: 2, height: '100%' }}>
                                    <CardMedia
                                        component="img"
                                        image={course.image}
                                        alt={course.title}
                                        sx={{
                                            height: 170,
                                            width: '100%',
                                            objectFit: 'cover',
                                            display: 'block',
                                        }}
                                    />

                                    <CardContent>
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight={700}
                                            sx={{ color: '#1e1e1e' }}
                                        >
                                            {course.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>

            {/* Related Videos */}
            <Grid md={12} sx={{ backgroundColor: '#f8f9fa', p: 4 }}>
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 700,
                        mb: 4,
                        color: '#2c2c2c',
                    }}
                >
                    Related Videos
                </Typography>

                <Grid container spacing={4}>
                    {videoList.map((video, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <Box
                                sx={{
                                    width: '100%',
                                    aspectRatio: '16/9',
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    boxShadow: 3,
                                }}
                            >
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={video.url}
                                    title={video.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{ borderRadius: '8px' }}
                                />
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Grid>

            {/* form */}
            <Grid container sx={{ backgroundColor: '#f4f6f8', p: 4 }}>
                <Grid item xs={12}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: '#ff2e8d',
                            mb: 4,
                            textAlign: 'center',
                        }}
                    >
                        Submit the form, and we will get in touch with you.
                    </Typography>
                </Grid>

                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            name="name"
                            label="Name*"
                            placeholder="Enter your name"
                            variant="outlined"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            sx={{
                                borderRadius: '12px',
                                backgroundColor: '#fff',
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            name="mobile"
                            label="Mobile Number*"
                            placeholder="Enter your mobile number"
                            variant="outlined"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            sx={{
                                borderRadius: '12px',
                                backgroundColor: '#fff',
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControl
                            fullWidth
                            sx={{ backgroundColor: '#fff', borderRadius: '12px' }}
                        >
                            <Select
                                name="class"
                                value={selectClass}
                                onChange={(e) => setSelectClass(e.target.value)}
                                displayEmpty
                                variant="outlined"
                            >
                                <MenuItem disabled value="">
                                    Please select the class
                                </MenuItem>
                                <MenuItem value="10">10</MenuItem>
                                <MenuItem value="11">11</MenuItem>
                                <MenuItem value="12">12</MenuItem>
                                <MenuItem value="Repeaters">Repeaters</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md="auto">
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#0062ff',
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 4,
                                py: 1.5,
                                borderRadius: 2,
                                mt: { xs: 2, md: 0 },
                                '&:hover': {
                                    backgroundColor: '#005ecb',
                                },
                            }}
                            onClick={() =>
                                console.log('Submitted:', { name, mobile, selectClass })
                            }
                        >
                            Submit
                        </Button>
                    </Grid>

                    <Grid item>
                        <Box
                            component="img"
                            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                            alt="WhatsApp"
                            sx={{ width: 50, height: 50 }}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <DetailAutoPopUp isOpen={openPopup} onClose={handleClosePopup} />


        </Grid>
    );
};
export default RepeatersNEET;